import "../styles/Home.scss";
import logoImage from "../assets/logo.png";

const Logo = () => {
  return <img className="Logo" src={logoImage} alt=""></img>;
};

export default Logo;
